import React from 'react';
import Heading from '../../Typography/Heading';
function MessageBlockHeader(_a) {
    var children = _a.children, id = _a.id;
    return (React.createElement("div", { className: "elmo-message-block__header", "data-testid": "elmo-message-block-header-".concat(id || 'default') },
        React.createElement(Heading, { type: "title", size: "sm" }, children)));
}
export default MessageBlockHeader;
